export default "__VITE_ASSET__BRUGyF0O__"